<template>
    <div>
        <form-group :label="item.displayName" :name="item.name" v-for="(item, idx) in accessKeys" :key="idx">
            <md-select v-if="item.type === 'select'" v-model="item.value">
                <md-option v-for="(option, jdx) in item.options" :key="jdx" :value="option.value">
                    {{ option.displayName }}
                </md-option>
            </md-select>
            <md-input v-else v-model.trim="item.value" :type="item.type" />
        </form-group>
    </div>
</template>
<script>
/**
 * @typedef {Object} AccessKeyOption
 * @property {string} displayName
 * @property {any} value
 */

/**
 * @typedef {Object} AccessKeyFieldValue
 * @property {string} displayName
 * @property {string} name
 * @property {boolean} isRequired
 * @property {string | null} type
 * @property {AccessKeyOption[] | null} options
 * @property {any} value
 */
export default {
    name: 'GenericKeys',
    props: {
        initialValue: {
            type: Array,
            default: () => [
                /**
                 * @type {AccessKeyFieldValue[]}
                 */
                {
                    displayName: 'API Key',
                    name: 'apiKey',
                    value: '',
                    type: 'text',
                    options: null
                }
            ]
        }
    },
    data() {
        return {
            /**
             * @type {AccessKeyFieldValue[]}
             */
            accessKeys: []
        };
    },
    watch: {
        initialValue: {
            immediate: true,
            deep: true,
            handler(newValue) {
                if (!newValue) {
                    return;
                }
                this.accessKeys = newValue.map(
                    /**
                     *
                     * @param {AccessKeyFieldValue} item
                     */
                    (item) => {
                        return {
                            ...item,
                            value: item.value || ''
                        };
                    }
                );
            }
        }
    }
};
</script>

<style scoped lang="scss"></style>
